import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ForAllService } from "../for-all.service";

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  comunicacionSecciones: any;
  @Input() seccionesGuardadas: Observable<any>;
  comunicacionIdiomas: any;
  @Input() idiomasGuardados: Observable<any>;

  seccionesDemo:any[] = [];
  seccionesDemo2:any[] = [];

  idiomas: any;
  // preguntas: any[] = [];
  // nombreEmpresa: string;
  nombreIdioma: string;
  cargando = true;

  numerosMapeados: number[] = [];
  idiomasAdicionales: any[] = [];

  constructor(
    private forallService: ForAllService,
  ) { }

  ngOnInit() {
    // this.getIdiomas();
    this.comunicacionIdiomas = this.idiomasGuardados.subscribe( (datos:any) => {
      if(datos != null){
        console.log("se envio datos desde componente base: ",datos);
        this.idiomas = datos;
        this.idiomas.forEach(idioma => {
          if(idioma.tipoIdioma != '3'){
            this.idiomasAdicionales.push(idioma);
          }
        });
      }
    });
    this.comunicacionSecciones = this.seccionesGuardadas.subscribe( (datos:any) => {
      console.log("comunicacionSecciones desde componente base: ",datos);
      if(datos != null){
        this.seccionesDemo = datos.seccionesDemo;
        // this.seccionesDemo2 = datos.seccionesDemo;
        // this.seccionesDemo2[0].questions.forEach(practice1 => {
        //   practice1.questionLanguage.forEach(element => {
        //   this.seccionesDemo2[0].questions.questionLanguage.question.replace(element.practice4all,'<code>'+element.practice4all+'</code>')
        // });
        //
        // });
        this.mapearNumeros();
        this.cargando = false;
        console.log('this.seccionesDemo2',this.seccionesDemo2);

      }
    });
  }

  mapearNumeros(){
    this.numerosMapeados = [];
    let contadorActual = 0;
    for (let i = 0; i < this.seccionesDemo[0].questions.length; i++) {
      if(i % 2 == 0){ //si es numero par
        contadorActual++;
        this.numerosMapeados.push(contadorActual);
      }
      else{ //si es numero impar
        this.numerosMapeados.push(contadorActual);
      }
    }
    // console.log("numerosMapeados:",this.numerosMapeados);

  }

  cambiaIdioma(event){
    this.nombreIdioma = event.value.nombreIdioma;
  }
}
